<ng-template #settingsTemplate>
    <app-tool-setting label="Linkerhand">
        <app-button (click)="openTool(true)" class="icon">
            <i class="fas fa-plus"></i>
        </app-button>
    </app-tool-setting>
    <app-tool-setting label="Rechterhand">
        <app-button (click)="openTool()" class="icon">
            <i class="fas fa-plus"></i>
        </app-button>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <div (click)="onHandClick()" [ngStyle]="{transform: flipped ? 'scaleX(-1)' : null }">
        <img [src]="path" width="220" height="300">
    </div>
</ng-template>
